module.exports = __webpack_public_path__ + "static/media/sales.784551dd.png";